export default build =>
    build.mutation({
        query(payload) {
            console.log("payload",payload)
            return {
                url: '/course/editCourse',
                method: 'POST',
                body: payload,
            };
        },
        invalidatesTags: ['allCourses'],
       
    })
